import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const CryptoGamingRules = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Helmet>
        <title>Crypto Gaming Rules | SpinSaga Crypto Casino</title>
        <meta name="description" content="Read the SpinSaga Crypto Casino Gaming Rules covering wager acceptance, game rounds, settlement, provably fair games, and dispute handling." />
        <link rel="canonical" href="https://coin.spinsagacasino.com/crypto-gaming-rules/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="SpinSaga Casino" />
        <meta property="og:url" content="https://coin.spinsagacasino.com/crypto-gaming-rules/" />
        <meta property="og:title" content="Crypto Gaming Rules | SpinSaga Crypto Casino" />
        <meta property="og:description" content="Read the SpinSaga Crypto Casino Gaming Rules covering wager acceptance, game rounds, settlement, provably fair games, and dispute handling." />
        <meta property="og:image" content="https://coin.spinsagacasino.com/512x512.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Crypto Gaming Rules | SpinSaga Crypto Casino" />
        <meta name="twitter:description" content="Read the SpinSaga Crypto Casino Gaming Rules covering wager acceptance, game rounds, settlement, provably fair games, and dispute handling." />
        <meta name="twitter:image" content="https://coin.spinsagacasino.com/512x512.png" />
      </Helmet>
      <div
        className="container bg-color-rg space-bottom content-only"
        style={{ marginTop: 60, padding: 20, paddingLeft: 35 }}
      >
        <div className="inner-smallspace-rg">
          <div className="row">
            <div className="col-md-12">
              <div className="content-page-design">
                <h2>{t("cryptoGamingRulesPage.title")}</h2>

                <p>{t("cryptoGamingRulesPage.intro1")}</p>
                <p>{t("cryptoGamingRulesPage.intro2")}</p>

                <h3>{t("cryptoGamingRulesPage.s1Heading")}</h3>
                <p>{t("cryptoGamingRulesPage.s1c1")}</p>
                <p>{t("cryptoGamingRulesPage.s1c2")}</p>
                <p>{t("cryptoGamingRulesPage.s1c3")}</p>
                <p>{t("cryptoGamingRulesPage.s1c4")}</p>

                <h3>{t("cryptoGamingRulesPage.s2Heading")}</h3>
                <p>{t("cryptoGamingRulesPage.s2c1")}</p>
                <p>{t("cryptoGamingRulesPage.s2c2")}</p>
                <p>{t("cryptoGamingRulesPage.s2c3")}</p>
                <p>{t("cryptoGamingRulesPage.s2c4")}</p>
                <p>{t("cryptoGamingRulesPage.s2c5")}</p>
                <p>{t("cryptoGamingRulesPage.s2c6")}</p>

                <h3>{t("cryptoGamingRulesPage.s3Heading")}</h3>
                <p>{t("cryptoGamingRulesPage.s3c1")}</p>
                <p>{t("cryptoGamingRulesPage.s3c2")}</p>
                <p>{t("cryptoGamingRulesPage.s3c3")}</p>
                <p>{t("cryptoGamingRulesPage.s3c4")}</p>

                <h3>{t("cryptoGamingRulesPage.s4Heading")}</h3>
                <p>{t("cryptoGamingRulesPage.s4c1")}</p>
                <p>{t("cryptoGamingRulesPage.s4c2")}</p>
                <p>{t("cryptoGamingRulesPage.s4c3")}</p>
                <p>{t("cryptoGamingRulesPage.s4c4")}</p>
                <p>{t("cryptoGamingRulesPage.s4c5")}</p>

                <h3>{t("cryptoGamingRulesPage.s5Heading")}</h3>
                <p>{t("cryptoGamingRulesPage.s5c1")}</p>
                <p>{t("cryptoGamingRulesPage.s5c2")}</p>
                <p>{t("cryptoGamingRulesPage.s5c3")}</p>
                <p>{t("cryptoGamingRulesPage.s5c4")}</p>
                <p>{t("cryptoGamingRulesPage.s5c5")}</p>

                <h3>{t("cryptoGamingRulesPage.s6Heading")}</h3>
                <p>{t("cryptoGamingRulesPage.s6c1")}</p>
                <p>{t("cryptoGamingRulesPage.s6c2")}</p>
                <p>{t("cryptoGamingRulesPage.s6c3")}</p>
                <p>{t("cryptoGamingRulesPage.s6c4")}</p>

                <h3>{t("cryptoGamingRulesPage.s7Heading")}</h3>
                <p>{t("cryptoGamingRulesPage.s7c1")}</p>
                <p>{t("cryptoGamingRulesPage.s7c2")}</p>
                <p>{t("cryptoGamingRulesPage.s7c3")}</p>
                <p>{t("cryptoGamingRulesPage.s7c4")}</p>
                <p>{t("cryptoGamingRulesPage.s7c5")}</p>

                <h3>{t("cryptoGamingRulesPage.s8Heading")}</h3>
                <p>{t("cryptoGamingRulesPage.s8c1")}</p>
                <p>{t("cryptoGamingRulesPage.s8c2")}</p>
                <p>{t("cryptoGamingRulesPage.s8c3")}</p>
                <p>{t("cryptoGamingRulesPage.s8c4")}</p>
                <p>{t("cryptoGamingRulesPage.s8c5")}</p>

                <h3>{t("cryptoGamingRulesPage.s9Heading")}</h3>
                <p>{t("cryptoGamingRulesPage.s9c1")}</p>
                <p>{t("cryptoGamingRulesPage.s9c2")}</p>
                <p>{t("cryptoGamingRulesPage.s9c3")}</p>
                <p>{t("cryptoGamingRulesPage.s9c4")}</p>

                <h3>{t("cryptoGamingRulesPage.s10Heading")}</h3>
                <p>{t("cryptoGamingRulesPage.s10c1")}</p>
                <p>{t("cryptoGamingRulesPage.s10c2")}</p>
                <p>{t("cryptoGamingRulesPage.s10c3")}</p>
                <p>{t("cryptoGamingRulesPage.s10c4")}</p>
                <p>{t("cryptoGamingRulesPage.s10c5")}</p>

                <h3>{t("cryptoGamingRulesPage.s11Heading")}</h3>
                <p>{t("cryptoGamingRulesPage.s11c1")}</p>
                <ul>
                  <li>{t("cryptoGamingRulesPage.s11c2")}</li>
                  <li>{t("cryptoGamingRulesPage.s11c3")}</li>
                  <li>{t("cryptoGamingRulesPage.s11c4")}</li>
                  <li>{t("cryptoGamingRulesPage.s11c5")}</li>
                  <li>{t("cryptoGamingRulesPage.s11c6")}</li>
                  <li>{t("cryptoGamingRulesPage.s11c7")}</li>
                </ul>
                <p>{t("cryptoGamingRulesPage.s11c8")}</p>

                <h3>{t("cryptoGamingRulesPage.s12Heading")}</h3>
                <p>{t("cryptoGamingRulesPage.s12c1")}</p>
                <p>{t("cryptoGamingRulesPage.s12c2")}</p>
                <p>{t("cryptoGamingRulesPage.s12c3")}</p>

                <h3>{t("cryptoGamingRulesPage.s13Heading")}</h3>
                <p>{t("cryptoGamingRulesPage.s13c1")}</p>
                <p>{t("cryptoGamingRulesPage.s13c2")}</p>
                <p>{t("cryptoGamingRulesPage.s13c3")}</p>
                <p>{t("cryptoGamingRulesPage.s13c4")}</p>

                <h3>{t("cryptoGamingRulesPage.s14Heading")}</h3>
                <p>{t("cryptoGamingRulesPage.s14c1")}</p>
                <p>{t("cryptoGamingRulesPage.s14c2")}</p>

                <h3>{t("cryptoGamingRulesPage.s15Heading")}</h3>
                <p>{t("cryptoGamingRulesPage.s15c1")}</p>
                <p>{t("cryptoGamingRulesPage.s15c2")}</p>

                <h3>{t("cryptoGamingRulesPage.s16Heading")}</h3>
                <p>{t("cryptoGamingRulesPage.s16c1")}</p>
                <p>{t("cryptoGamingRulesPage.s16c2")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CryptoGamingRules;
